import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { tags } from "../../../consts/Tags";
import ButtonRounded from "../buttons/ButtonRounded";

export default class ReponsePopUp extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {text, isTrue, isLast = false, endFunc}) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager
        this.isTrue = isTrue
        this.scene = scene;
        scene.add.existing(this);

        // Ajout fond
        let background = this.scene.add.rectangle(0, 0, this.scene.width, 400, isTrue ? Colors.Elmt.Green : Colors.Elmt.Red).setOrigin(0,0.5);
        this.add(background)

        // Ajout titre
        let titre = this.scene.add.text(627, 56, isTrue ? "Bonne réponse !" : "Mauvaise réponse !", {
            fontFamily: FONTS.Inter28ExtraLight,
            fontSize: '102px',
            color: isTrue ? Colors.Text.GreenJardin : Colors.Text.Rose
        }).setOrigin(0)
        this.add(titre)

        // Ajout texte
        let textElmt = this.scene.add.rexTagText(titre.x, titre.y + titre.height + 16, text, {
            fontFamily: FONTS.Inter28SemiBold,
            fontSize: '40px',
            color: Colors.Text.White,
            wordWrap: { width: 1100 },
            tags: tags
        }).setOrigin(0)
        this.add(textElmt)

        // Ajout bouton suivant
        let nextButton = new ButtonRounded(this.scene, 1216, textElmt.y + textElmt.height + 40, {
            text: isLast ? "Continuer" : "Question suivante",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        })
        this.add(nextButton)
        nextButton.y += nextButton.height/2
        nextButton.setClickFunction( () => {
            endFunc();
        })

        // MAJ des positions
        background.height = nextButton.y + nextButton.height/2 + 48;
        background.y = (400 - background.height)/2

        titre.y -= background.height/2
        textElmt.y -= background.height/2
        nextButton.y -= background.height/2

        this.setSize(background.width, background.height);
    }

    animIn(){
        let audio = 'Good'
        if(!this.isTrue)
            audio = 'Wrong'
        this.soundManager.playOnce(audio)
        this.x -= this.scene.width
        this.scene.tweens.add({
            targets: this,
            x: 0,
            duration: 500,
        })
    }

    animOut(endFunc){
        this.scene.tweens.add({
            targets: this,
            x: -this.scene.width,
            duration: 500,
            onComplete: () => {
                this.destroy(true);
                if(endFunc)
                    endFunc();
            }
        })
    }
}